import { DispatchAssignmentRead } from 'src/common/external/bambi-api/bambiApi';
import { formatFullName } from 'src/common/util/formatFullName';

export const ANY_DRIVER = 'any-driver';
export function useAssignmentOptions(assignments: DispatchAssignmentRead[]) {
  return [
    { label: 'Any Driver', value: ANY_DRIVER },
    ...assignments.map((assignment) => {
      return {
        label: formatFullName(assignment.driver),
        value: assignment.id,
      };
    }),
  ];
}
